/*
 * Controls the behaviour of the slide in/out
 * mobile menu
 *
 * @author eric.bailey@barrelny.com
 *
 */

var Nav = {
	init:function(){
		this.nav = '.js-nav';
		this.toggle = '.js-menuToggle';

		this.events();
	},

	events:function(){
		var self = this;

		$(window)
			.on('scroll',
				$.throttle(
					500,
					this.MobileHeaderRetract.bind(self)
				)
			);

		$('a',this.nav).on('click', this.transition.bind(this) );

		$('body')
			.on('click','.js-menuToggle',this.transition.bind(this));
	},

	/*
	 * Let CSS handle the state change animation
	 *
	 * @params	void
	 * @returns	void
	 */
	transition: function(e){
		var $el = $(e.currentTarget);

		if ( $el.parents('.sub-menu').length ){
			$('.sub-menu a').removeClass('is-active');
			$el.addClass('is-active');
		}

		if (!Modernizr.csstransitions){
			this.fallback();
		} else {
			$(this.nav).toggleClass('is-visible');
			$('body').toggleClass('nav--is-visible');
		}
	},

	/*
	 * GSAP animation fallback
	 *
	 * @params	void
	 * @returns	void
	 */
	fallback: function(){
		if ( $(this.nav).width() > 0 ) {
			TweenMax.to($(this.nav),0.4,{width:0});
		} else {
			TweenMax.to($(this.nav),0.4,{width:'100%'});
		}
	},

	/*
	 * Slide the header on from the top
	 * when the user is scrolling up. Hide
	 * the menu when the user is scrolling down
	 *
	 * @params	void
	 * @returns	void
	 */
	MobileHeaderRetract: function(){
		if ( !MUR.isSmall() ) return;

		var
			prev = this.cachedScroll || false,
			pos = $(window).scrollTop(),
			$el = $('.header-wrapper');

		this.cachedScroll = pos;

		if (pos < 70){
			$el.removeClass('retract');
			return;
		}

		if (Math.abs(prev - pos) <= 40){
			return;
		}

		if (prev > pos){
			$el.removeClass('retract');
		} else {
			$el.addClass('retract');
		}
	},

	drop:function(){
		this.cachedScroll = false;

		$('body')
			.off('click','.js-menuToggle');

		$('.sub-menu a').off(this.transition);
	}
}

module.exports = Nav;
